import { EuiFormRow, EuiSpacer, EuiTitle } from '@elastic/eui'
import { CampaignType } from '../../api/interfaces'
import { NewSegmentFinder } from '../../components/finders/NewSegmentFinder'
import React from 'react'

export const InternetInventoryExplorer: React.FC = () => {
  return (
    <>
      <EuiTitle size={'s'}>
        <h2>Explore Internet Audiences</h2>
      </EuiTitle>
      <EuiSpacer/>
      <EuiFormRow label={'Audience Segments'} fullWidth>
        <NewSegmentFinder campaignType={CampaignType.Internet} isInvalid={false} onSegmentClicked={() => {}} />
      </EuiFormRow>
    </>
  )
}